import { useEffect } from 'react';
import { getUser } from 'src/utils/Common';

const useStatusLogger = isOnline => {
    useEffect(() => {
        if (!isOnline) {

            let user = getUser();


            const logDetails = {
                timestamp: new Date().toISOString(),
                user: user,
                tenantId: user.TenantId,
                isOnline: isOnline
            };

            const offlineLogs = JSON.parse(localStorage.getItem('statusLogs')) || [];

            offlineLogs.push(logDetails);

            localStorage.setItem('statusLogs', JSON.stringify(offlineLogs));
        }
    }, [isOnline]);
}

export default useStatusLogger;